import React from "react";
import PageContainer from "../../src/components/container/Container";

export default function Privacy_policy() {
  return (
    <PageContainer 
      title="Privacy Policy - CodeElan Technologies" 
      description="Learn about how CodeElan Technologies collects, uses, and protects your personal information in accordance with our privacy policy."
    >
      {/* Hero Section */}
      <section className="hero-section contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div className="hero-content">
                  <div className="hero-accent"></div>
                  <h1 className="hero-title">
                    <span className="text-primary">Privacy Policy</span>
                  </h1>
                  <p className="hero-subtitle">
                    Your privacy is important to us. Learn how we protect and handle your personal information.
                  </p>
                  <div className="hero-meta">
                    <span className="text-muted">Last updated: November 10, 2024</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Privacy Policy Content */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="policy-content">
                <div className="policy-intro">
                  <p className="policy-description">
                This Privacy Policy describes Our policies and procedures on the
                collection, use and disclosure of Your information when You use
                the Service and tells You about Your privacy rights and how the
                law protects You. We use Your Personal data to provide and
                improve the Service. By using the Service, You agree to the
                collection and use of information in accordance with this
                    Privacy Policy.
              </p>
              </div>

                <div className="policy-section">
                  <h2 className="policy-section-title">Interpretation and Definitions</h2>
                  
                  <h3 className="policy-subtitle">Interpretation</h3>
                  <p className="policy-text">
                  The words of which the initial letter is capitalized have
                  meanings defined under the following conditions. The following
                  definitions shall have the same meaning regardless of whether
                  they appear in singular or in plural.
                </p>

                  <h3 className="policy-subtitle">Definitions</h3>
                  <p className="policy-text">For the purposes of this Privacy Policy:</p>
                  <ul className="policy-list">
                    <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
                    <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to CodeElan Technologies Pvt. Ltd., E402, S3 Lifestyle Internal Rd, Apartments, Pimple Saudagar, Pune, Maharashtra 411027.</li>
                    <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
                    <li><strong>Country</strong> refers to: Maharashtra, India</li>
                    <li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
                    <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
                    <li><strong>Service</strong> refers to the Website.</li>
                    <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company.</li>
                    <li><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.</li>
                    <li><strong>Website</strong> refers to CodeElan Technologies, accessible from https://codeelan.com/</li>
                    <li><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
                </ul>
              </div>

                <div className="policy-section">
                  <h2 className="policy-section-title">Collecting and Using Your Personal Data</h2>
                  
                  <h3 className="policy-subtitle">Types of Data Collected</h3>
                  
                  <h4 className="policy-subtitle-sm">Personal Data</h4>
                  <p className="policy-text">
                  While using Our Service, We may ask You to provide Us with
                  certain personally identifiable information that can be used
                  to contact or identify You. Personally identifiable
                  information may include, but is not limited to:
                  </p>
                  <ul className="policy-list">
                    <li>Email address</li>
                    <li>First name and last name</li>
                    <li>Phone number</li>
                    <li>Usage Data</li>
                  </ul>

                  <h4 className="policy-subtitle-sm">Usage Data</h4>
                  <p className="policy-text">
                  Usage Data is collected automatically when using the Service.
                    Usage Data may include information such as Your Device's
                  Internet Protocol address (e.g. IP address), browser type,
                  browser version, the pages of our Service that You visit, the
                  time and date of Your visit, the time spent on those pages,
                    unique device identifiers and other diagnostic data.
                  </p>

                  <h4 className="policy-subtitle-sm">Tracking Technologies and Cookies</h4>
                  <p className="policy-text">
                  We use Cookies and similar tracking technologies to track the
                  activity on Our Service and store certain information.
                    The technologies We use may include:
                  </p>
                  <ul className="policy-list">
                    <li><strong>Cookies or Browser Cookies:</strong> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent.</li>
                    <li><strong>Web Beacons:</strong> Certain sections of our Service and our emails may contain small electronic files known as web beacons that permit the Company to count users who have visited those pages.</li>
                  </ul>
                  </div>

                <div className="policy-section">
                  <h2 className="policy-section-title">Use of Your Personal Data</h2>
                  <p className="policy-text">
                    The Company may use Personal Data for the following purposes:
                  </p>
                  <ul className="policy-list">
                    <li>To provide and maintain our Service, including to monitor the usage of our Service.</li>
                    <li>To manage Your Account: to manage Your registration as a user of the Service.</li>
                    <li>For the performance of a contract: the development, compliance and undertaking of the purchase contract.</li>
                    <li>To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication.</li>
                    <li>To provide You with news, special offers and general information about other goods, services and events.</li>
                    <li>To manage Your requests: To attend and manage Your requests to Us.</li>
                    <li>For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets.</li>
                    <li>For other purposes: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service.</li>
                  </ul>
              </div>

                <div className="policy-section">
                  <h2 className="policy-section-title">Security of Your Personal Data</h2>
                  <p className="policy-text">
                The security of Your Personal Data is important to Us, but
                remember that no method of transmission over the Internet, or
                method of electronic storage is 100% secure. While We strive to
                use commercially acceptable means to protect Your Personal Data,
                We cannot guarantee its absolute security.
              </p>
                </div>

                <div className="policy-section">
                  <h2 className="policy-section-title">Contact Us</h2>
                  <p className="policy-text">
                If you have any questions about this Privacy Policy, You can
                contact us:
                  </p>
                  <ul className="policy-list">
                  <li>By email: info@codeelan.com</li>
                    <li>By visiting this page on our website: <a href="/contactus" className="text-primary">Contact Us</a></li>
                    <li>By phone number: +91-8208650598</li>
                </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
}
